module.exports = __webpack_public_path__ + "static/media/flame.9cc37bd5.svg";